import { render, staticRenderFns } from "./FAQS.vue?vue&type=template&id=9e4c9b86&scoped=true"
import script from "./FAQS.vue?vue&type=script&lang=js"
export * from "./FAQS.vue?vue&type=script&lang=js"
import style0 from "./FAQS.vue?vue&type=style&index=0&id=9e4c9b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4c9b86",
  null
  
)

export default component.exports